import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { isDesktop } from "react-device-detect";
import { Container, Box, Typography } from '@mui/material';
import { TextField,InputAdornment, IconButton, Button  } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Spinner } from '/@/app/components/Spinner';

import SendIcon from '@mui/icons-material/Send';
import ChatIcon from '@mui/icons-material/Chat';
import SchoolIcon from '@mui/icons-material/School';
import BlockIcon from '@mui/icons-material/Block';
import StopIcon from '@mui/icons-material/Stop';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import FeedbackIcon from '@mui/icons-material/Feedback';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AutoDeleteOutlinedIcon from '@mui/icons-material/AutoDeleteOutlined';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import PushPinIcon from '@mui/icons-material/PushPin';

import { AppContext } from '/@/app/AppContext';
import { useApi} from '/@/app/Api';
import { messageStackState } from "/@/app/states/messageStackState";


const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#f5f7fb',
    ...theme.typography.body2,

    borderRadius: theme.shape.borderRadius * 1.5,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(4.5),
    },
    //
    textAlign: "left",
    color: theme.palette.text.primary,
	whiteSpace:'pre-line',
	wordWrap:'break-word',
}));



const Round = ({round, onDelete}) =>
{
const api=useApi();
const { t } = useTranslation();
const [disliked, setDisliked] = useState(round.output?.reduce((a,o,i)=>({...a,[i]:o.disliked}),{}));
const [comment, setComment] = useState(round.output?.reduce((a,o,i)=>({...a,[i]:{'t':o.comment,'c':!!o.comment}}),{}));
const [deletion, setDeletion] = useState(null);
const [pin, setPin] = useState(round.pinned);

const format_autodelete = (autodelete) =>
{
	let d = autodelete - Math.floor(Date.now() / 1000);
	let u='duration.seconds';
	if (d>86400) { d=Math.floor(d/86400); u='duration.days'; }
	else if (d>3600) {d=Math.floor(d/3600); u='duration.hours'; }
	else if (d>60) {d=Math.floor(d/60); u='duration.minutes'; };

	return t('Автоудаление через')+' '+d+' '+t(u);
};

const [autodelete, setAutodelete] = useState(round.autodelete);

const handleDislike = (event,index) =>
{
	let options={ 'round_id':round['round_id'],'output_index':index};
	if (disliked[index]) options={...options,remove:true};
	if (comment[index]?.['t']) options['comment']=comment[index]['t'];
	api.request( `chatbot/dislike`,options, {method:'POST',api_url:'v2'} )
	.then(re => {
		setDisliked(prev=>({...prev,[index]:prev[index]?false:true}));
	});
};
const toggleComment = (event,index) =>
{
	setComment(prev=>({...prev,[index]:{'v':prev[index]?.['v']?false:true,'t':prev[index]?.['t']?prev[index]['t']:null,'c':prev[index]?.['c'], 'timeout':prev['index']?.['timeout']}}));
};

const handleComment = (event,index,action='input') =>
{
	let timeout=comment[index]?.['timeout'];
	if (timeout) clearTimeout(timeout);
	let options={ 'round_id':round['round_id'],'output_index':index, };
	if (action=='input')
	{
		timeout=setTimeout(() =>
		{
			api.request( `chatbot/dislike`,{...options, 'comment':event.target.value, },{'method':'POST',api_url:'v2'} )
			.then(re => {
				setComment(prev=>({...prev,[index]:{'v':prev[index]?.['v'],'t':prev[index]?.['t'],'c':event.target.value.length>0,'timeout':null}}));
			});
		}, 1000);
		setComment(prev=>({...prev,[index]:{'v':prev[index]?.['v'],'t':event.target.value,'c':false,'timeout':timeout}}));
	};
	if (action=='clear') api.request( `chatbot/dislike`,{...options, 'comment':null, },{'method':'POST',api_url:'v2'} )
	.then(re => {
		setComment(prev=>({...prev,[index]:{'v':prev[index]?.['v'],'t':'','c':false,'timeout':null}}));
	});
};
const handleDelete = (event) =>
{
	let timeout=deletion;
	if (timeout) clearTimeout(timeout);
	if (timeout)
	{
		api.request( `chatbot/delete`,{ 'round_id':round['round_id']},{'method':'POST',api_url:'v2',} )
		.then(re => {
			onDelete(round.id);
		});
		setDeletion(prev=>null);
		return;
	};
	timeout=setTimeout(() =>
	{
		setDeletion(prev=>null);
	}, 5000);
	setDeletion(prev=>timeout);
};

const handlePin = (event) =>
{
	api.request( `chatbot/pin`,{ 'round_id':round['round_id'], 'pin':pin!==true},{'method':'POST',api_url:'v2'} )
	.then(re => {
		setPin(re.pinned);
		setAutodelete(re.autodelete);
	});
};

const replaceWithLinks = (text) =>
{
	const regex = /\[(.*?)\]/g;
	const parts = text.split(regex);

	return parts.map((part, index) =>
	{
		if (index % 2 === 1) {
			return ( <a href={part.startsWith('http')?part:'https://'+part} key={index} target="_blank"> {part} </a>);
		} else {
			return part;
		}
	});
};

const copyText = (event,index) =>
{
	let text=round.output.filter((o,i)=>(i==index || index===undefined) ).map(o=>(o.header?'# '+o.header.trim()+"\n\n":'')+o.text.trim()).join("\n\n");
	text+="\n\n"+t("Информация из https://nestarenie.ru и")+"\n"+'https://app.nestarenie.expert/cabinet/chatbot';
	if (navigator.clipboard)
	{
		navigator.clipboard.writeText(text)
		.then(() =>
		{
			messageStackState.addMessage({ text: t('Тест скопирован'), tags: "secondary", autoHide: 3000, });
		})
		.catch((err) =>
		{
			console.error('Failed to copy text: ', err);
		});
	}
	else
	{
		const textArea = document.createElement('textarea');
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand('copy');
		document.body.removeChild(textArea);
		messageStackState.addMessage({ text: t('Тест скопирован'), tags: "secondary", autoHide: 3000, });
	};

};

return (
<Box width="100%" sx={{marginBottom:2}} >
<Typography sx={{whiteSpace:'pre-line',wordWrap:'break-word',marginBottom:1}}>{round.input}</Typography>
<Item>
{round.output && (
round.output.map((o,i)=>(
<Box key={i} sx={{marginTop:i>0?2:0}}>
<Typography >{replaceWithLinks(o.text)}{o.status && <span>{o.status}</span>}</Typography>
{!o.incomplete && (
<Box>
<Typography>
{o.similarity && (<span sx={{marginTop:0.3}} >{t('Соответствие')}: {o.similarity.toFixed(2)} </span>)}
<IconButton sx={{marginLeft:1}} title={disliked[i]?t('Отменить сообщение о плохом ответе'):t('Сообщить о плохом ответе')} onClick={() => handleDislike(event,i)}>{disliked[i] ? <ThumbDownIcon /> : <ThumbDownOffAltIcon />}</IconButton>
{disliked[i]?<IconButton sx={{marginLeft:1}} title={t('Оставить комментарий')} onClick={() => toggleComment(event,i)}>{comment[i]?.['c']?<FeedbackIcon />:<FeedbackOutlinedIcon/>}</IconButton>:''}
<IconButton title={t('Копировать ответ')} onClick={() => copyText(event,i)}><ContentCopyIcon /></IconButton>
{round.output.length>1 && i==round.output.length-1 && (<IconButton title={t('Копировать все ответы')} onClick={() => copyText(event)}><CopyAllIcon /></IconButton>)}
{i==round.output.length-1 && (<IconButton title={pin===true ?t('Открепить'):t('Закрепить')} onClick={() => handlePin(event)}>{pin==true?<PushPinIcon/>:<PushPinOutlinedIcon />}</IconButton>)}
{i==round.output.length-1 && (<IconButton title={deletion?t('Удалить сейчас'):(pin===true?t('Удалить'):format_autodelete(autodelete))} sx={{ color: deletion?'error.main':null, transform: deletion?'scale(1.2)':null, }} onClick={() => handleDelete(event)}>{deletion?<DeleteForeverIcon />:(pin===true?<DeleteOutlinedIcon/>:<AutoDeleteOutlinedIcon />)}</IconButton>)}
</Typography>
{disliked[i]&&comment[i]?.['v']?<TextField value={comment[i]?.['t']||''} onChange={()=>handleComment(event,i)} fullWidth InputProps={{ endAdornment: comment[i]?.['c']?<InputAdornment position="end"> <IconButton onClick={()=>handleComment(event,i,'clear')}> <ClearIcon /> </IconButton> </InputAdornment>:null, }}/>:''}
</Box>)}
</Box>))
)}
{!round.output && !round.loading && (<Typography>{t("Нет ответа")}</Typography>)}
</Item>
{round.loading && !round.output && (  <Spinner size={20}/> )}
</Box>
);
};

export const ChatbotView = () =>
{
const api=useApi();

const { t } = useTranslation();
const { featureEnabled, bootstrapData } = useContext(AppContext);

const [rounds, setRounds] = useState([]);
const [beginRounds, setBeginRounds] = useState([]);
const [endRounds, setEndRounds] = useState([]);
const [loadingRound, setLoadingRound] = useState(null);
const [dataView,setDataView]=useState({size:null});
const dataInfo=useRef({total:null,retrieved:null,fetching:null,scroll:'end'});
const [statusMessage,setStatusMessage] = useState({});

const { mainViewportRef,bottomExtraPadding} = useContext(AppContext);
const beginBufRef = useRef(null);
const endBufRef = useRef(null);
const contentRef = useRef(null);
const roundIdRef = useRef(1);
const statusRef = useRef(null);

const [inputValue, setInputValue] = useState('');
const inputUpdated = useRef(false);
const inputRef = useRef(null);

const [submitStatus, setSubmitStatus] = useState(null);
const streamAbortRef = useRef(null);

const chatModeSeq=featureEnabled('experimental')?['consultant','expert','kb-1','kb-2','kb-3','na']:(featureEnabled('sponsorship')||featureEnabled('premium')?['consultant','kb-1','kb-2','kb-3']:['kb-1','kb-2','kb-3']);
const chatModeDefault=(featureEnabled('experimental') || featureEnabled('premium') || featureEnabled('sponsorship'))?'consultant':'kb-1';
const [chatMode, setChatMode]=useState(chatModeSeq.includes(bootstrapData.settings['chatmode'])?bootstrapData.settings['chatmode']: chatModeDefault);


const deleteRound = (id) =>
{
	setRounds(prev => prev.filter(r => r.id !== id));
};

const fetchPage = useCallback(function()
{
	const pageHeight=mainViewportRef.current.clientHeight;
	if (mainViewportRef.current.scrollTop>pageHeight/2) return;

	const loadedHeight=beginBufRef.current?.scrollHeight;
	if (loadedHeight<pageHeight && (dataInfo.current.retrieved??-1)<(dataInfo.current.total??0))
	{
		setDataView((prev)=>({mode:'begin',size:(dataInfo.current.retrieved??0)+5}));
		return;
	};


	setRounds((prev) => [...beginRounds,...prev]);
	if (beginRounds.length) setBeginRounds([]);

	dataInfo.current.scrollTop=mainViewportRef.current.scrollTop;
	dataInfo.current.scrollHeight=mainViewportRef.current.scrollHeight;

});

const handleChange = (event) =>
{
	setInputValue(event.target.value);
};

const handleStreaming = async () =>
{
	setSubmitStatus('stream');
	if (streamAbortRef.current) streamAbortRef.current.abort();
	const abort_controller=new AbortController();
	streamAbortRef.current=abort_controller;

	setLoadingRound({input:inputValue,loading:true,output:null});
	setStatusMessage({})

	try
	{

	const response=await api.request( `chatbot/`+chatMode,{ input:inputValue }, { method:'POST', streaming:true, signal:abort_controller.signal, api_url:'v2'});
	setInputValue("");
	if (!response.body)
	{
		setLoadingRound(null);
		throw new Error("Streaming not supported");
	};
	if (response.status==402)
	{
		setLoadingRound(null);
		setStatusMessage({text:t('Лимит вопросов исчерпан'),type:'grey'})
		return;
	};


	const reader = response.body.getReader();
	const decoder = new TextDecoder('utf-8');
	let buffer = "";

	let round_id=null,autodelete=null;
	let received_outputs=[];
	let received_output={text:'',incomplete:true};
	let error=null;
	let limits=null;
	const m=mainViewportRef.current;
	dataInfo.current.scroll='end';
	while (true)
	{
		const { value, done } = await reader.read();
		if (done) break;

		let chunk= decoder.decode(value, { stream: true });
		buffer += chunk;

		const events = buffer.split("\n\n");
		buffer = events.pop() ?? "";

		for (const event of events)
		{
			if (!event.startsWith("data:"))
			{
				try
				{
					error=JSON.parse(event.trim()).error;
				} catch (e)
				{
					error=t('Неожиданный ответ сервера');
				};
				continue;
			};
			const payload = JSON.parse( event.replace("data:", "").trim());
			if (payload.text) received_output.text+=payload.text;
			if ('limits' in payload) limits=payload.limits;
			if ('status' in payload) received_output.status=payload.status;
			if ('round_ids' in payload) round_id=payload.round_ids;
			if ('autodelete' in payload) autodelete=payload.autodelete;
			if (payload.similarity) { received_output.similarity=payload.similarity; received_outputs.push(received_output); received_output={text:''}; };
			setLoadingRound({input:inputValue,loading:true,output:[...received_outputs,received_output]});
		};
	};
	reader.releaseLock();

	//dataInfo.current.scroll='keep';
	if (received_output.error) { error=(error||'')+received_output.error; delete received_output['error']; };
	if (received_output.text) received_outputs.push(received_output);
	if (!received_output['status']) delete received_output['incomplete']
	//if (!error) delete received_output['incomplete'];
	
	const round={id:roundIdRef.current++,'round_id':round_id,input:inputValue,autodelete:autodelete, output:[received_output]};

	if (limits)
	{
		let limit=limits.filter(l=>l.type=='C').sort((a,b)=>a.limit-b.consumption-b.limit+b.consumption)[0];
		limit['left']=limit.limit-limit.consumption;
		if (limit.limit && limit.left/limit.limit<2) setStatusMessage({type:'grey',text:t('chatbot-limit-part-1')+' '+limit.left+' '+t('из')+' '+limit.limit+' '+t('chatbot-limit-part-2')});
	};

	if (error) setStatusMessage({text:error,type:'error'});

	setRounds((prev) => [...prev, round]);
	setLoadingRound(null);

	}
	catch (err)
	{
		if (err.name != "AbortError") console.error(err);
	}
	finally
	{
		streamAbortRef.current=null;
		setSubmitStatus(null);
	};

};

const handleNA = () =>
{
	setStatusMessage({text:t('chatbot-mode-na'),type:'info'});
};

const handleSubmit = () =>
{
	const input=inputValue.trim();
	if (!input) return;
	if (chatMode=='na') return handleNA();
	setSubmitStatus('disabled');
	if (input!='?' && !chatMode.startsWith('kb-')) return handleStreaming();

	setLoadingRound({input:input,loading:true,output:null});
	setStatusMessage({});

	dataInfo.current.scroll='end';
	api.request( `chatbot/kb`,{ input:input, outputs:chatMode.split('-')[1] },{ method:'POST',api_url:'v2', supressGlobalError:true} )
	.then(data =>
	{
		console.log('data',data);
		const chunk=data.map(r=>({id:roundIdRef.current++,round_id:r.round_ids, 'input':r.input,'output':r.output,timestamp:r.timestamp,'autodelete':r.autodelete}));
		setEndRounds((prev)=>[...chunk]);
		const error=data.filter(r=>r.error);
		setStatusMessage(error?{text:error[0]?.error,type:'error'}:{})
		dataInfo.current.scroll= 'end';
		setSubmitStatus(null);
	})
	.catch(error =>
	{
		console.log(error);
		setLoadingRound(null);
		setSubmitStatus(null);
		setStatusMessage({text:String(error),type:'error'});
		setInputValue(input);
	});
	setInputValue("");
}

const handleAbort = () =>
{
	streamAbortRef.current.abort();
	setRounds((prev) => [...prev, {...loadingRound,id:roundIdRef.current++}]);
	setLoadingRound(null);
}

const handleKeyDown = (event) =>
{
	if (event.key === "Enter" && !event.shiftKey && isDesktop)
	{
		event.preventDefault();
		handleSubmit();
	};
	if (event.key === "ArrowUp" && !inputValue && rounds.length)
	{
		setInputValue(prev=>rounds[rounds.length-1].input);
		inputUpdated.current=true;
		event.preventDefault();
	};
};
useEffect(() =>
{
	if (!inputUpdated.current) return;
	const textarea = inputRef.current.querySelector('textarea');
	const length = textarea.value.length;
	textarea.setSelectionRange(length, length);
	inputUpdated.current=false;
}, [inputValue]);

const handleChatMode = (event) =>
{
	const newChatMode=chatModeSeq[(chatModeSeq.indexOf(chatMode)+1)%chatModeSeq.length];
	setChatMode(newChatMode);
	api.request( `user/settings`,{ 'chatmode':newChatMode }, { method:'POST', api_url:'v2'}).then((re)=>{});
	bootstrapData.settings['chatmode']=newChatMode;
};

useEffect( () =>
{
	if (dataInfo.current.fetching) return;
	if ((dataInfo.current.retrieved??0)>=(dataView.size??0)) return;
	if ((dataInfo.current.retrieved??-1)>=(dataInfo.current.total??0)) return;
	dataInfo.current.fetching=dataView.size-(dataInfo.current.retrieved??0);
	api.request( `chatbot/rounds`,{ offset:dataInfo.current.retrieved,limit:dataInfo.current.fetching},{ method:'POST',api_url:'v2'} )
	.then(data => {
		if (!Array.isArray(data) && 'error' in data)
		{
			dataInfo.current={total:null,retrieved:null,fetching:null};
			return;
		};

		const chunk=data.reverse().map(r=>({id:roundIdRef.current++,round_id:r.round_ids, 'input':r.input,'output':r.output,timestamp:r.timestamp,'pinned':r.pinned, 'autodelete':r.autodelete}));
		if (dataInfo.current.retrieved && dataView.mode=='begin')
			setBeginRounds((prev)=>[...chunk, ...prev]);
		else if (dataInfo.current.retrieved)
			setRounds((prev) => [...chunk, ...prev ]);
		else if (dataView.mode=='begin')
			setBeginRounds((prev)=>chunk);
		else
			setRounds((prev) => chunk);
		const totalRows=data.length?data[0]['count']:dataInfo.current.retrieved;
		const rowsRetieved=(dataInfo.current.retrieved??0)+data.length;

		dataInfo.current={total:totalRows,retrieved:rowsRetieved,fetching:null,scroll:dataInfo.current.scroll};
	})
	.catch(error => { dataInfo.fetching=null;console.log(error); });
},[dataView]);

useEffect(() =>
{
	let lastPos = 0;
	const mainViewport=mainViewportRef.current;
	const handleScroll = () => {
		var pos=mainViewport.scrollTop;
		var scrollingUp=pos<lastPos;
		lastPos=pos;
		dataInfo.current.scroll= pos+mainViewport.clientHeight>= mainViewport.scrollHeight ? 'end' :'keep';
		if (scrollingUp && (dataInfo.current.retrieved??-1)<(dataInfo.current.total??0)) fetchPage();
	};
	mainViewport.addEventListener('scroll', handleScroll);
	return () => mainViewport.removeEventListener('scroll', handleScroll);
}, [dataView]);

useEffect(() =>
{
	const m=mainViewportRef.current;
	if (dataInfo.current.scroll=='keep')
	{
		// do nothing
		//mainViewportRef.current.scrollTop=mainViewportRef.current.scrollHeight-(dataInfo.current.scrollHeight-dataInfo.current.scrollTop);
	}
	else if (dataInfo.current.scroll=='end')
	{
		statusRef.current.scrollIntoView();
		//m.scrollTop = m.scrollHeight-m.clientHeight;

	}
	else if (dataInfo.current.scroll=='last')
	{
		const lastRound=contentRef.current?.lastElementChild;
		if (lastRound) lastRound.scrollIntoView();
	};
}, [rounds]);

useEffect(() =>
{
	if (!loadingRound) return;
	if (dataInfo.current.scroll=='end')
	{
		statusRef.current.scrollIntoView();
		///mainViewportRef.current.scrollTop = mainViewportRef.current.scrollHeight-mainViewportRef.current.clientHeight;
	};
}, [loadingRound]);

useEffect(() =>
{
	fetchPage();
},[beginRounds]);

useEffect(() =>
{
	if (endRounds.length==0) return;
	const pageHeight=mainViewportRef.current.clientHeight;

	const loadedHeight=endBufRef.current?.scrollHeight;
	dataInfo.current.scroll=loadedHeight<=pageHeight?'end':'last';
	setRounds((prev) => [...prev.filter(r=>r.id!=-1), ...endRounds]);
	setEndRounds([]);
	setLoadingRound(null);
},[endRounds]);


return (
<>
<Container maxWidth="md">
<Box
	ref={beginBufRef}
	style={{ position: 'absolute', visibility: 'hidden', height: 'auto', }}
>
{beginRounds.map((round) => (
	<Round key={round.id} round={round} onDelete={deleteRound} />
))}
</Box>
<Box
	ref={endBufRef}
	style={{ position: 'absolute', visibility: 'hidden', height: 'auto', }}
>
{endRounds.map((round) => (
	<Round key={round.id} round={round} onDelete={deleteRound} />
))}
</Box>

<Box ref={contentRef}>
{rounds.map((round) => (
	<Round key={round.id} round={round} onDelete={deleteRound}/>
))}
{loadingRound && <Round round={loadingRound} onDelete={deleteRound} />}
</Box>

<Box ref={statusRef}>
{statusMessage.text && ( <Typography color={{'access':'warning',}[statusMessage.type] || statusMessage.type || null}>{statusMessage.type=='error'?t('Ошибка')+ ': ':''}{statusMessage.text}</Typography>)}
</Box>

<Box
	sx={{
		position: 'sticky',
		bottom:  0,
		zIndex: 1000,
		backgroundColor: 'white',
		'&::after': {
			content: '""',
			position: 'absolute',
			top: '100%',
			left: 0,
			right: 0,
			height: bottomExtraPadding?'80px':'24px',
			backgroundColor: 'white',
		}
	}}
>

<TextField
	ref={inputRef}
	fullWidth
	placeholder={t("chatbot-input-prompt")}
	inputProps={{ autoComplete: 'off', inputMode: 'text', type: 'text', }}
	multiline
	value={inputValue}
	onChange={handleChange}
	onKeyDown={handleKeyDown}
	InputProps={{
		endAdornment: (
			<InputAdornment position="end">
				<Button onClick={handleChatMode} title={t('chatbot-mode-'+chatMode)}> {chatMode.startsWith('kb-') ? ( chatMode.split('-')[1]):( chatMode=='expert'?<SchoolIcon color="action"/>:(chatMode=='consultant'?<ChatIcon color="action"/>:<BlockIcon color="action"/>)) } </Button>
				<IconButton onClick={()=>submitStatus=='stream'?handleAbort():handleSubmit()} disabled={submitStatus=='disabled'}> {submitStatus=='stream'?<StopIcon/>:<SendIcon />} </IconButton>
			</InputAdornment>
		),
	}}
	sx={{
		marginTop:1,
	}}

/>
</Box>
</Container>

</>
);
} // ChatbotView
